import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "mt-2 text-sm" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]

import { toRefs } from 'vue';

interface MessageInterface {
  main: string;
  sub: string;
  dateTime: { date: string; time: string }[];
}

interface Props {
  message: MessageInterface;
  styleClass?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarOverlappingMessage',
  props: {
    message: {},
    styleClass: {}
  },
  setup(__props: any) {

const props = __props;

const { message, styleClass } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_unref(styleClass))
    }, [
      _createElementVNode("span", {
        class: "font-semibold",
        textContent: _toDisplayString(_unref(message).main)
      }, null, 8, _hoisted_1),
      _createElementVNode("span", {
        class: "ml-1",
        textContent: _toDisplayString(_unref(message).sub)
      }, null, 8, _hoisted_2)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { textContent: 'Conflicts on:' }, null, -1)),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(message).dateTime, (dt, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("span", {
              class: "font-semibold",
              textContent: _toDisplayString(dt.date)
            }, null, 8, _hoisted_4),
            _createElementVNode("span", {
              class: "ml-1",
              textContent: _toDisplayString(dt.time)
            }, null, 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})